import {HA_PULSE_SWAP_REVIEWS_PRICE} from '../experiments';
import TestExposureOnce from '../test-exposure-once';
import HitFooter from '../../components/Hit/HitSubComponents/HitFooter/HitFooter';
import {isTestOn} from '../../utils/abacus';
import TestHitFooter from './hit-footer';
import React, {Component} from 'react';
import withAbacus from '../with-abacus/with-abacus';

export const testExposure = new TestExposureOnce(HA_PULSE_SWAP_REVIEWS_PRICE);

export class HitFooterContainer extends Component {
    static defaultProps = {
        abacus: {},
        reviewCount: 0
    }

    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const {reviewCount} = this.props;
        if (reviewCount > 0) {
            testExposure.trigger(HA_PULSE_SWAP_REVIEWS_PRICE);
        }
    }

    // only update if price changed
    shouldComponentUpdate(nextProps) {
        const {props} = this;
        const {rate} = nextProps;
        return rate !== props.rate;
    }

    render() {
        const {abacus} = this.props;
        if (isTestOn(abacus, HA_PULSE_SWAP_REVIEWS_PRICE)) {
            return <TestHitFooter {...this.props} />;
        }
        return <HitFooter {...this.props} />;
    }
}

export default withAbacus(HitFooterContainer);



// WEBPACK FOOTER //
// ./src/universal/abacus/swap-reviews-price/index.js